module.exports = __webpack_public_path__ + "img/login-logo.6ab1e33d.png";